import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const ForgotPassword = () => {
  const navigate = useNavigate()
  const [emailOrPhone, setEmailOrPhone] = useState('')
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const validate = () => {
    if (!emailOrPhone.trim()) return 'Please enter your email or phone'
    if (!/^\S+@\S+\.\S+$/.test(emailOrPhone) && !/^\d{10,15}$/.test(emailOrPhone))
      return 'Enter a valid email or phone'
    return ''
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const err = validate()
    if (err) { setError(err); return }
    setIsSubmitting(true)
    try {
      await new Promise((resolve) => setTimeout(resolve, 1500))
      toast.success('Verification code sent to your email')
      navigate('/verify-code', { state: { email: emailOrPhone } })
    } catch (err) {
      console.error('Failed:', err)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center p-4">
      <div className="bg-white border border-[#e9ecef] rounded-xl shadow-sm p-10 w-full max-w-[440px]">
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-9 h-9 bg-[#2c3e50] rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <span className="text-xl font-bold text-[#2c3e50]">Admin Panel</span>
        </div>

        <h2 className="text-[1.6rem] font-semibold text-[#2c3e50] text-center mb-1">Forgot Password</h2>
        <p className="text-center text-[#7f8c8d] text-sm mb-8">
          Enter your email address and we'll send you a verification code
        </p>

        <form onSubmit={handleSubmit} className="space-y-5" noValidate>
          <div>
            <label className="block text-xs font-medium text-[#7f8c8d] uppercase tracking-wide mb-1.5">
              Email or Phone
            </label>
            <input type="text" value={emailOrPhone} onChange={(e) => { setEmailOrPhone(e.target.value); setError('') }}
              className={`w-full border rounded-lg px-4 py-3 text-sm text-[#2c3e50] focus:outline-none transition-colors ${
                error ? 'border-[#e74c3c]' : 'border-[#e9ecef] focus:border-[#3498db]'
              }`}
              placeholder="admin@example.com" />
            {error && <p className="text-[#e74c3c] text-xs mt-1">{error}</p>}
          </div>

          <button type="submit" disabled={isSubmitting}
            className="w-full bg-[#2c3e50] hover:bg-[#34495e] text-white font-semibold py-3 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed mt-2">
            {isSubmitting ? 'Sending…' : 'Send Verification Code'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default ForgotPassword
